<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Filter type</label>
          <b-form-select v-if="homeSelectedComponent === 'collaborativeTaskList' && collaborativeTaskListSelectedTab === 'All Task'" v-model="filterTypeSelected" :options="collaborativeTaskListFilterTypeOptions"></b-form-select>
          <b-form-select v-else v-model="filterTypeSelected" :options="generalFilterTypeOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Filter direction</label>
          <b-form-select v-model="filterDirectionSelected" :options="filterDirectionOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="taskListFilterBy">Filter task</b-button>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "TaskListFilterBy",
    data() {
      return {
        filterTypeSelected: 'None',
        filterDirectionSelected: 'Ascending',
        collaborativeTaskListFilterTypeOptions: [
          {value: 'None', text: 'None'},
          {value: 'Assigned task', text: 'Assigned task'},
          {value: 'Unassigned task', text: 'Unassigned task'},
          {value: 'Completed task', text: 'Completed task'},
          {value: 'Incomplete task', text: 'Incomplete task'}
        ],
        generalFilterTypeOptions: [
          {value: 'None', text: 'None'},
          {value: 'Completed task', text: 'Completed task'},
          {value: 'Incomplete task', text: 'Incomplete task'}
        ],
        filterDirectionOptions: [
          {value: 'Ascending', text: 'Ascending'},
          {value: 'Descending', text: 'Descending'},
        ]
      }
    },
    methods: {
      taskListFilterBy() {
        this.$store.dispatch('setFilterTaskListProperties', {
          filterTypeSelected: this.filterTypeSelected,
          filterDirectionSelected: this.filterDirectionSelected
        })
        this.hideModal('task-list-option-modal')
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "homeSelectedComponent",
        "collaborativeTaskListSelectedTab",
        "isCollaborativeListAdministrator"
      ])
    },
  }
</script>

<style scoped>
  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }
</style>
